import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {FILE_UPLOADER} from "../../../../../componentes/file-uploader/file-uploader.component";
import {MascaraCpf} from "../../../../../helper/MascaraCpf";
import {MascaraTelefoneCelular} from "../../../../../helper/MascaraTelefoneCelular";
import {Subscription} from "rxjs";

@Component({
  selector: 'app-dados-conciliador-mediador',
  templateUrl: './dados-conciliador-mediador.component.html',
  styleUrls: ['./dados-conciliador-mediador.component.css']
})
export class DadosConciliadorMediadorComponent implements OnInit, OnDestroy {

  @Input() tituloAnexarDocumentos: string;
  @Input() formulario: FormGroup;
  @Input() conciliadorNaoRequerente: boolean;
  @Input() modalConciliadorMediador: boolean = false;
  @Input() requerente: number;
  @Output() tipoAtuacao = new EventEmitter<string>();
  @ViewChild(FILE_UPLOADER, {static: false}) fileUploader: any;
  nomeBloqueado = false;
  telefoneInvalido = false; // NOVA VARIÁVEL
  private atuacaoSubscription: Subscription;
  private atuacaoTeste: number = 0;

  constructor(private fb: FormBuilder) {
  }

  ngOnInit() {
    this.getFormularioRequerente().addControl('id', new FormControl(null));
    this.getFormularioRequerente().addControl('cpf', new FormControl('', [Validators.required, Validators.pattern(/^\d{3}\.\d{3}\.\d{3}-\d{2}$/)]));
    this.getFormularioRequerente().addControl('nome', new FormControl('', Validators.required));
    this.getFormularioRequerente().addControl('telefone',  new FormControl('', Validators.required));
    this.getFormularioRequerente().addControl('email', new FormControl('', [Validators.required, Validators.email]));
    this.getFormularioRequerente().addControl('funcao', new FormControl('', Validators.required));
    this.getFormularioRequerente().addControl('atuacao', new FormControl('', Validators.required));

    if(this.getFormularioRequerente().get('id').value == null){
      this.getFormularioRequerente().addControl('arquivo', new FormArray([], Validators.required));
    }else{
      this.getFormularioRequerente().addControl('arquivo', new FormArray([]));
    }

    this.getFormularioRequerente().addControl('requerente', new FormControl(this.requerente, Validators.required));
    const REQUERENTE :number = 1;
    if(this.requerente == REQUERENTE) {
      this.atuacaoSubscription = this.getFormularioRequerente().get('atuacao').valueChanges.subscribe(valor => {
        this.tipoAtuacao.emit(valor);
      });
    }
  }


  ngOnDestroy() {
    this.getFormularioRequerente().removeControl('id');
    this.getFormularioRequerente().removeControl('cpf');
    this.getFormularioRequerente().removeControl('nome');
    this.getFormularioRequerente().removeControl('telefone');
    this.getFormularioRequerente().removeControl('email');
    this.getFormularioRequerente().removeControl('funcao');
    this.getFormularioRequerente().removeControl('atuacao');
    this.getFormularioRequerente().removeControl('arquivo');
    this.getFormularioRequerente().removeControl('requerente');

    if (this.atuacaoSubscription) {
      this.atuacaoSubscription.unsubscribe();
    }
  }

  onArquivosChange(arquivos: any[]) {
    const arquivosControl = this.getFormularioRequerente().get('arquivo') as FormArray;
    arquivosControl.clear();
    if (arquivos && arquivos.length) {
      arquivos.forEach(arq => {
        arquivosControl.push(this.fb.group({
          nomeArquivo: arq.nomeArquivo,
          conteudo: arq.conteudo
        }));
      });
    }
    arquivosControl.markAsTouched();
    arquivosControl.updateValueAndValidity();
  }

  getControleFormularioPorNome(ctrl: string): AbstractControl {
    return this.getFormularioRequerente().get(ctrl);
  }

  aplicarFormatacaoCpfNoInput(event: any) {
      let formatted = new MascaraCpf().aplicar(event);
      const cpfControl =  this.getFormularioRequerente().get('cpf');
      cpfControl.setValue(formatted, { emitEvent: false });
  }

  aplicarFormatacaoTelefoneNoInput(event: any) {
    let {rawValue, masked} = new MascaraTelefoneCelular().aplicar(event);
    this.getFormularioRequerente().get('telefone').setValue(masked, {emitEvent: false});
    this.telefoneInvalido = (rawValue.length > 0 && rawValue.length < 10);
  }
  get possuiAnexos(): boolean {
    const arquivosControl = this.getFormularioRequerente().get('arquivo') as FormArray;
    return arquivosControl && arquivosControl.length > 0;
  }

  getFormularioRequerente() {
    if (this.conciliadorNaoRequerente) return this.formulario as FormGroup;
    if (!this.conciliadorNaoRequerente) return this.formulario.get('dadosRequerente') as FormGroup;
  }
}
